import { Link } from "react-router-dom";
import "./styles.scss";
import { HiChartSquareBar } from "react-icons/hi";
import {
  FaStore,
  FaShoppingBag,
  FaLightbulb,
  FaMapMarked,
  FaListAlt,
  FaLink,
  FaPeopleArrows,
  FaUserCheck,
  FaWhatsapp,
  FaHistory,
  FaPaintBrush,
  FaDog,
  FaGamepad,
  FaWrench,
  FaTv
} from "react-icons/fa";
import { FiGrid } from "react-icons/fi";


export default function SidebarPanelNavigation({ isAdmin }) {
  const renderNavigation = () => {
    return (
      <nav className="text-secondary">
        {isAdmin && (
          <ul>
            <li>
              <HiChartSquareBar size={20} />
              <Link className="ml-2 text-secondary" to="/admin/dashboard">
                Dashboard
              </Link>
            </li>
            <li className="my-2">
              <FaStore size={20} />
              <Link className="ml-2 text-secondary" to="/admin/usuarios">
                Usuários
              </Link>
            </li>

            <li className="my-2">
              <FaMapMarked size={20} />
              <Link className="ml-2 text-secondary" to="/admin/localidades">
                Localidades
              </Link>
            </li>
            <li>
              <FiGrid size={20} />
              <Link className="ml-2 text-secondary" to="/admin/categorias">
                Categorias
              </Link>
            </li>
            <br />


            <li>
              <FiGrid size={20} />
              <Link className="ml-2 text-secondary" to="/admin/parceiros">
                Parceiros
              </Link>
            </li>
            <br />
            <li>
              <FaListAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/tipos-categorias">
                Tipos de Categorias
              </Link>
            </li>
            <br />
            <li>
              <FaListAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/evento">
                Eventos
              </Link>
            </li>
            <br />
            <li>
              <FaLightbulb size={20} />
              <Link className="ml-2 text-secondary" to="/adicionar-oferta-ia">
                Nova Oferta com IA
              </Link>
            </li>
            <br />
            <li>
              <FaShoppingBag size={20} />
              <Link className="ml-2 text-secondary" to="/admin/products">
                Todos os Produtos
              </Link>
            </li>

            <br />
            <li>
              <FaListAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/banner">
                Todos os Banners
              </Link>
            </li>
            <br />
            <li>
              <FaListAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/ribbon-badges">
                Todos os Emblemas
              </Link>
            </li>
            <br />
            <li>
              <FaLink size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos">
                Controle de Acessos
              </Link>
            </li>
            <br />
            <li>
              <FaShoppingBag size={20} />
              <Link className="ml-2 text-secondary" to="/admin/controle/shoppe">
                Controle da Shoppe
              </Link>
            </li>
            <br />
            <li>
              <FaDog size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos/pet">
                Grupos Pet
              </Link>
            </li>
            <br />
            <li>
              <FaGamepad size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos/games">
                Grupos Games
              </Link>
            </li>
            <br />
            <li>
              <FaWrench size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos/ferramentas">
                Grupos Ferramentas
              </Link>
            </li>
            <br />
            <li>
              <FaTv size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos/tvs">
                Grupos TVS
              </Link>
            </li>
            <br />
            <li>
              <FaPeopleArrows size={20} />
              <Link className="ml-2 text-secondary" to="/admin/divulgacao/shoope">
                Divulgação
              </Link>
            </li>
            <br />
            <li>
              <FaUserCheck size={20} />
              <Link className="ml-2 text-secondary" to="/admin/leads">
                Leads
              </Link>
            </li>
            <br />
            <li className="my-2">
              <FaWhatsapp size={20} />
              <Link className="ml-2 text-secondary" to="/admin/automacao-whatsapp">
                Automação WhatsApp
              </Link>
            </li>
            <br />
            <li>
              <FaHistory size={20} />
              <Link className="ml-2 text-secondary" to="/admin/historico-mensagens">
                Histórico de mensagens
              </Link>
            </li>
            <br />
            <li>
              <FaPaintBrush size={20} />
              <Link className="ml-2 text-secondary" to="/admin/tema">
                Personalizar Tema
              </Link>
            </li>
          </ul>
        )}
        {!isAdmin && (
          <ul>


            <li className="my-2">
              <FaLightbulb size={20} />
              <Link className="ml-2 text-secondary" to="/adicionar-oferta-ia">
                Nova Oferta com IA
              </Link>
            </li>
            <br />
            <li className="my-2">
              <FaStore size={20} />
              <Link className="ml-2 text-secondary" to="/poster/produtos">
                Meus Produtos
              </Link>
            </li>
            <br />
            <li>
              <FaUserCheck size={20} />
              <Link className="ml-2 text-secondary" to="/poster/leads">
                Leads
              </Link>
            </li>
            <br />
            <li className="my-2">
              <FaWhatsapp size={20} />
              <Link className="ml-2 text-secondary" to="/poster/automacao-whatsapp">
                Automação WhatsApp
              </Link>
            </li>
            <br />
            <li>
              <FaHistory size={20} />
              <Link className="ml-2 text-secondary" to="/poster/historico-mensagens">
                Histórico de mensagens
              </Link>
            </li>

          </ul>
        )}
      </nav>
    );
  };
  //#0052B3
  return (
    <div className="sidebar-panel-nav d-none d-sm-none d-md-none d-lg-block text-secondary">
      {isAdmin && <h5 className="mb-4">Painel de Controle</h5>}
      {!isAdmin && <h5 className="mb-4">Painel das Ofertas do Postador</h5>}
      {renderNavigation()}
    </div>
  );
}
